// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHomeBatteryIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M20 8v13c0 .55-.45 1-1 1h-2V10c0-.55-.45-1-1-1h-2V8c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8c-.55 0-1 .45-1 1v12H5c-.55 0-1-.45-1-1V8c0-.32.16-.63.42-.81l7-5a.99.99 0 0 1 1.16 0l7 5c.26.19.42.49.42.81m-5.5 7h-1.81l.3-2.44a.504.504 0 0 0-.9-.37l-3 4c-.11.15-.13.35-.05.52a.5.5 0 0 0 .45.28h1.81l-.3 2.44c-.03.23.1.44.31.53.06.02.12.04.19.04.15 0 .3-.07.4-.2l3-4c.11-.15.13-.35.05-.52a.5.5 0 0 0-.45-.28" />
  </g>
);
export default SvgHomeBatteryIcon;
SvgHomeBatteryIcon.displayName = 'SvgHomeBatteryIcon';
